// Vorys Cart Email Capture — auto-apply VORYS10 discount
(function() {
  'use strict';

  const DISCOUNT_CODE = 'VORYS10';
  const LS_KEY = 'vorys_email_claimed';

  function init(box) {
    if (!box || box.dataset.vorysInit) return;
    box.dataset.vorysInit = '1';

    // Zaten kullanıcı kayıt olduysa, "claimed" göster
    if (localStorage.getItem(LS_KEY)) {
      box.classList.add('is-claimed');
      return;
    }

    const form = box.querySelector('form');
    const input = box.querySelector('input[type=email]');
    const btn = box.querySelector('button[type=submit]');
    const errorEl = box.querySelector('.vorys-cart-email__error');

    if (!form || !input || !btn) return;

    form.addEventListener('submit', async function(e) {
      e.preventDefault();
      const email = input.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        errorEl.textContent = 'Geçerli bir e-posta yaz lütfen.';
        errorEl.hidden = false;
        return;
      }
      errorEl.hidden = true;
      btn.disabled = true;
      btn.setAttribute('data-loading', '1');

      try {
        // Shopify customer/marketing opt-in via /contact endpoint
        const fd = new FormData();
        fd.append('form_type', 'customer');
        fd.append('utf8', '✓');
        fd.append('contact[tags]', 'newsletter,cart-capture');
        fd.append('contact[email]', email);
        await fetch('/contact', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } });

        // Clarity + Pixel tracking
        if (typeof clarity === 'function') {
          clarity('event', 'cart_email_submitted');
        }
        if (typeof fbq === 'function') {
          fbq('track', 'Lead', { content_name: 'cart_email_capture', value: 0, currency: 'TRY' });
        }

        // localStorage flag (tekrar göstermesin)
        localStorage.setItem(LS_KEY, email);

        // Success state
        box.classList.add('is-submitted');

        // 1 saniye sonra discount URL'ine yönlendir (auto-apply + cart redirect)
        setTimeout(() => {
          window.location.href = '/discount/' + DISCOUNT_CODE + '?redirect=/cart';
        }, 1100);

      } catch (err) {
        errorEl.textContent = 'Bir sorun oldu, tekrar dene.';
        errorEl.hidden = false;
        btn.disabled = false;
        btn.removeAttribute('data-loading');
      }
    });
  }

  function scan() {
    document.querySelectorAll('[data-vorys-cart-email]').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', scan);
  document.addEventListener('cart:refresh', scan);
  scan();
})();
